<div class="grid grid-cols-2 gap-4">
  <pm-form-input-checkbox
    class="col-span-1"
    [disabled]="isLoading()"
    [(ngModel)]="fixedYAxisZeroPoint"
    (ngModelChange)="onFixedYAxisZeroPointChange()"
  >
    {{ 'RESULT.VISIBILITY_OPTIONS.FIXED_Y_AXIS_ZERO_POINT.TITLE' | translate }}
  </pm-form-input-checkbox>
</div>
